var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5057 6.22941C23.2289 5.20141 22.4184 4.39087 21.3904 4.1141C19.5123 3.6001 11.9999 3.6001 11.9999 3.6001C11.9999 3.6001 4.48762 3.6001 2.60954 4.09433C1.60131 4.3711 0.771002 5.20141 0.494232 6.22941C0 8.10749 0 12.002 0 12.002C0 12.002 0 15.9164 0.494232 17.7747C0.771002 18.8027 1.58154 19.6132 2.60954 19.89C4.50739 20.404 11.9999 20.404 11.9999 20.404C11.9999 20.404 19.5123 20.404 21.3904 19.9097C22.4184 19.633 23.2289 18.8224 23.5057 17.7944C23.9999 15.9164 23.9999 12.0218 23.9999 12.0218C23.9999 12.0218 24.0197 8.10749 23.5057 6.22941Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60791 15.6001L15.855 12.0021L9.60791 8.40405V15.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6c789b8cf05947dd69f31060bc2ebbb5.svg";
export { ForwardRef as ReactComponent };